import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import TopicForm from '../components/TopicForm';
import {CLINICAL_NOTE_WRITING_TOPIC_CONSTRAINS} from 'constants/adminPupups';

const TopicUrl = '/api/v1/note_topics';

@inject('clinicalNoteWritingTopicsStore')
@inject('alertStore')
@observer
class AddTopic extends PureComponent {
  componentDidMount() {
    const {clinicalNoteWritingTopicsStore, match} = this.props;
    const id = match.params.id;
    clinicalNoteWritingTopicsStore.initNewTopic(id);
  }

  handleChange = e => {
    const {clinicalNoteWritingTopicsStore} = this.props;

    if (e.target.name === 'file') {
      clinicalNoteWritingTopicsStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      clinicalNoteWritingTopicsStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  validationProcess = resource => {
    let errors = validate(resource, CLINICAL_NOTE_WRITING_TOPIC_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {clinicalNoteWritingTopicsStore} = this.props;
    const topic = _.assign({}, clinicalNoteWritingTopicsStore.topic);
    const errors = this.validationProcess(topic);

    clinicalNoteWritingTopicsStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', topic.title);
    formData.append('file', topic.file, topic.file.name);
    formData.append('note_category_id', topic.categoryId)

    new HttpClient().multipart(TopicUrl, formData, 'POST').then(data => {
      clinicalNoteWritingTopicsStore.saveTopic(data.body.data.note_topic);
      clinicalNoteWritingTopicsStore.initNewTopic(topic.categoryId);
      this.props.alertStore.success('Topic successfully created');
      this.props.history.push(`/clinical-notes-writing/${topic.categoryId}/edit`);
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
    });
  };

  render() {
    return (
      <PageWrapper>
        <TopicForm submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default AddTopic;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/containers/AddTopic.js